import ResourcePattern from '../utils/resource-pattern';

export default ResourcePattern('produtos/catalogo');
